import React from 'react';

export type CountdownResult = {
  time: string;
  isExpired: boolean;
};

export function useCountdown(target: Date): CountdownResult {
  const [remaining, setRemaining] = React.useState(0);

  React.useEffect(() => {
    const update = () => setRemaining(Math.max(0, target.getTime() - Date.now()));
    update();
    const id = setInterval(update, 1_000);
    return () => clearInterval(id);
  }, [target]);

  const h = Math.floor(remaining / 3_600_000);
  const m = Math.floor((remaining % 3_600_000) / 60_000);
  const s = Math.floor((remaining % 60_000) / 1_000);

  return {
    time: `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`,
    isExpired: remaining <= 0,
  };
}
